function ManageBrands() {
	return (
		<span>Manage Brands - Coming Soon!</span>
	);
}

export default ManageBrands;